export * from './policy-terms-and-conditions.component';
